import fetch from "isomorphic-fetch";
import { X_API_KEY, GENERALI_X_API_KEY } from '../utils/Constants';
import { isGenerali } from "../utils/domain";

let prevURL = "";
let prevCallTime = -1;
let requestTimeInterval = 1000; //milliseconds

export function putService(url, data, callbackSuccess, callbackError) {
  if (prevURL === url && Date.now() - prevCallTime < 1000) {
    setTimeout(() => {
      putService(url, data, callbackSuccess, callbackError)
    }, requestTimeInterval);
    requestTimeInterval = (requestTimeInterval * 2);
    return;
  }

  prevCallTime = Date.now();
  prevURL = url;

  fetch(url, {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": isGenerali() ? GENERALI_X_API_KEY : X_API_KEY
    },
    method: "PUT",
    body: data
  })
    .then(response => response.json())
    .then(response => {
      console.log(response);
      callbackSuccess(response);
    })
    .catch(error => {
      console.log(error);
      callbackError(error);
    });
}